
import { CLIENT } from "../constant/actionTypes";

export default (state, action) => {
    if (typeof state == 'undefined') {
        state = {};
    }

    switch (action.type) {
        case CLIENT.USER_LIST.INITIATE:
            return { isFetching: true, data: action.payload };
        case CLIENT.USER_LIST.SUCCESS:
            return { isFetching: false, data: action.payload };
        case CLIENT.USER_LIST.ERROR:
            return { isFetching: false, data: action.payload };
        default:
            return state;
    }
};
